import {PermissionType} from '@hconnect/apiclient'
import {useUpmPlantContext} from '@hconnect/upm'
import type {DataScope} from '@hproduce/permissions'
import {checkPermissionAccessByDataScope, usePermissionsParsedQuery} from '@hproduce/permissions'
import {useMemo} from 'react'

/*
 * generic hook to check permissions by type and datascope
 */

export const usePermission = (
  type: PermissionType,
  dataScopeTestFn?: (dataScope: Partial<DataScope>) => boolean
) => {
  const {data: permissions} = usePermissionsParsedQuery([type])
  const {plantId: plantCode} = useUpmPlantContext()
  const {country: countryId} = useUpmPlantContext()

  return useMemo(() => {
    if (!permissions) {
      return false
    }
    const foundPermissions = permissions
      .filter(({parsedDataScope}) =>
        checkPermissionAccessByDataScope(countryId, plantCode, parsedDataScope)
      )
      .filter(({parsedDataScope}) => (dataScopeTestFn ? dataScopeTestFn(parsedDataScope) : true))

    const foundPermissionTypes = foundPermissions.map(({permissionType}) => permissionType)

    return foundPermissionTypes.includes(type)
  }, [permissions, type, plantCode, countryId, dataScopeTestFn])
}
